<template>
  <div class="point">
    <recharge type='2' :exclusive='1' />
  </div>
</template>

<script>
import recharge from './recharge.vue'
export default {
  components:{
    recharge
  },
  props:{},
  data(){
    return {
    }
  },
  watch:{},
  computed:{},
  methods:{},
  created(){},
  mounted(){}
}
</script>
<style lang="scss" scoped>

</style>